// extracted by mini-css-extract-plugin
export default {"root":"ReviewForm_root__9zKlT","submitButton":"ReviewForm_submitButton__mfuoW"};